module.exports = __webpack_public_path__ + "static/media/chek.4daf71ac.png";